import * as columns from '../../misc/Columns';
import { NewVocabRecord, UpdateVocabRecord } from '../../api/FracApi.ts';

export function convertEditDataAsUpdate(tab_name: string, editData: any, columns: columns.ColumnInfo[]): UpdateVocabRecord {
    return getRecord(tab_name, editData, columns, true) as UpdateVocabRecord;
}

export function convertEditDataAsNew(tab_name: string, editData: any, columns: columns.ColumnInfo[]): NewVocabRecord {
    return getRecord(tab_name, editData, columns, false) as NewVocabRecord;
}

function getRecord(tab_name: string, editData: any, columns: columns.ColumnInfo[], getId: boolean): NewVocabRecord | UpdateVocabRecord {
    const vocab_name = tab_name;
    var id = null;
    if (getId) {
        id = editData['id'];
    }
    const data_record: any[] = [];

    // for each column
    columns.forEach((col) => {
        if (!col.editable) {
            return;
        }

        if (col.id !== 'id') {
            var value = editData[col.id];
            data_record.push(value);
        }
    });

    var data = {
        'vocab_name': vocab_name,
        'data_record': data_record
    }
    if (getId) {
        data['id'] = String(id)
    }

    return data;
}